module.exports = __webpack_public_path__ + "img/9_71.6a0b9613.png";